
export class StepListItem {
    enable: Boolean = false;
    name: string;
    subject: string;
    description: string;
    icon: string = "star";

    constructor(name: string, subject: string, description: string, icon: string, enable: boolean) {
        this.name = name;
        this.subject = subject;
        this.description = description;
        this.icon = icon;
        this.enable = enable;
    }
   
}

